//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Notification from './Notification.vue'
import ClickOutside from 'vue-click-outside'
import API from '../../../../services/API'

export default {
    components: {
        Notification,
    },
    directives: {
        ClickOutside,
    },
    data() {
        return {
            showNotifications: false,
            notifications: [],
            loading: {
                notifications: false,
            },
        }
    },
    computed: {
        notificationIcon: function() {
            if (!this.notifications) {
                return '/build/v3/img/notification.svg'
            }

            const unreadNotifications = this.notifications.filter(notif => !notif.displayed_at)

            return unreadNotifications.length > 0 ? 'new' : ''
        },
    },
    mounted() {
        this.requestNotifications()
    },
    methods: {
        toggleNotificationCenter() {
            this.showNotifications = !this.showNotifications
        },
        hideNotificationCenter() {
            if (this.showNotifications) {
                this.showNotifications = false
            }
        },
        async requestNotifications() {
            try {
                this.loading.notifications = true
                const result = await API.getNotifications()
                this.notifications = result.items
            } catch (e) {
                this.notifications = []
            } finally {
                this.loading.notifications = false
            }
        },
    },
}
